import { $ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-full-sticky]')) return;

  fullStickyVisible();
}

function fullStickyVisible() {
  window.addEventListener('load', checkVisibilityFullSticky);
  window.addEventListener('resize', checkVisibilityFullSticky);
  window.addEventListener('scroll', checkVisibilityFullSticky);

  const stickyButton = $('[data-au-full-sticky-button]');
  stickyButton.addEventListener('click', (e) => {
    e.preventDefault();
    const moduleId = e.currentTarget.dataset.auFullStickyButton;

    if (moduleId) {
      const module = $(`[data-au-module-id=${moduleId}]`);

      window.scrollTo({
        top: module.offsetTop - (window.innerHeight - module.offsetHeight) / 2,
        behavior: 'smooth',
      });

      // if some focusable element on target, focus on first of them
      const focusableElemets =
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]), details:not([disabled]), summary:not(:disabled)';
      module.querySelectorAll(focusableElemets).forEach((focusableElement, index) => {
        if (!focusableElement) return;
        if (index === 0) {
          focusableElement.focus();
        }
      });
    }

    const el = e.currentTarget;
    const clickText = el.querySelector('[data-au-full-sticky-label]').innerText;
    const item_id = `sticky_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickBoton',
      item_id,
    });
  });
}

function checkVisibilityFullSticky() {
  const fullStickyModule = $('[data-au-full-sticky]');
  const moduleId = fullStickyModule.dataset.auFullSticky;
  const module = moduleId ? $(`[data-au-module-id=${moduleId}]`) : null;
  const footer = $('footer');
  const modulePos = module ? module.getBoundingClientRect() : null;
  const footerPos = footer ? footer.getBoundingClientRect() : null;

  if (
    (modulePos && modulePos.top <= window.innerHeight && modulePos.bottom >= 0) ||
    (footerPos && footerPos.top <= window.innerHeight && footerPos.bottom >= 0)
  ) {
    fullStickyModule.classList.add('au-full-sticky__hide');
  } else {
    fullStickyModule.classList.remove('au-full-sticky__hide');
  }
}

export default { init };
